var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            multiple: "",
                            name: "locationId",
                            id: "locationId",
                            label: "text",
                            filterable: false,
                            options: _vm.locationArr,
                            placeholder: "Select State"
                          },
                          on: {
                            change: _vm.changedValue,
                            input: function($event) {
                              return _vm.changedValueLocation()
                            },
                            search: _vm.onSearchLocation
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(option.text) +
                                        "\n                                        "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "selected d-center" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.locationId,
                            callback: function($$v) {
                              _vm.locationId = $$v
                            },
                            expression: "locationId"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n                                        Search State...\n                                    "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.locationError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "locationType",
                          id: "locationType",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.locationTypeArr,
                          placeholder: "Select Location Type"
                        },
                        model: {
                          value: _vm.locationType,
                          callback: function($$v) {
                            _vm.locationType = $$v
                          },
                          expression: "locationType"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-dropzone", {
                        ref: "bannerDropzone",
                        attrs: {
                          id: "drop1",
                          options: _vm.bannerDropzoneOptions,
                          destroyDropzone: false,
                          headers: _vm.bannerDropzoneOptions.headers,
                          name: "file"
                        },
                        on: {
                          "vdropzone-removed-file": _vm.removeSelectedBanner,
                          "vdropzone-success": _vm.bannerFileSuccess,
                          "vdropzone-duplicate-file": _vm.duplicateBanner,
                          "vdropzone-total-upload-progress":
                            _vm.progressOfUloadBanner
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.bannerCropError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("tinymce", {
                        ref: "tm",
                        attrs: {
                          plugins: [
                            "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                            "searchreplace wordcount visualblocks visualchars code fullscreen",
                            "insertdatetime media nonbreaking save table contextmenu directionality",
                            "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                          ],
                          id: "description"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.descriptionError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactno,
                            expression: "contactno"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "title",
                          placeholder: "Toll Free Number",
                          maxlength: "190"
                        },
                        domProps: { value: _vm.contactno },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.contactno = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.contactnoError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.flyer_label,
                            expression: "flyer_label"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "title",
                          placeholder: "Extra Content 1 Label",
                          maxlength: "190"
                        },
                        domProps: { value: _vm.flyer_label },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.flyer_label = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isFlyerUploaded
                        ? _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.flyer_labelError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-9 paddingleft0",
                      attrs: { id: "Cars2" }
                    },
                    [
                      _c("span", { attrs: { id: "flyerForm" } }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.flyerRadioValue,
                                expression: "flyerRadioValue"
                              }
                            ],
                            attrs: {
                              id: "flyerUploadManually",
                              type: "radio",
                              name: "flyerRadioValue",
                              value: "flyerDoc",
                              checked: "checked"
                            },
                            domProps: {
                              checked: _vm._q(_vm.flyerRadioValue, "flyerDoc")
                            },
                            on: {
                              change: function($event) {
                                _vm.flyerRadioValue = "flyerDoc"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Upload Docs\n                                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.flyerRadioValue,
                                expression: "flyerRadioValue"
                              }
                            ],
                            attrs: {
                              id: "flyerVideopUrl",
                              type: "radio",
                              name: "flyerRadioValue",
                              value: "flyerURL"
                            },
                            domProps: {
                              checked: _vm._q(_vm.flyerRadioValue, "flyerURL")
                            },
                            on: {
                              change: function($event) {
                                _vm.flyerRadioValue = "flyerURL"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Enter URL\n                                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isFlyerDoc
                        ? [
                            _c("vue-dropzone", {
                              ref: "flyerDropzone",
                              attrs: {
                                id: "drop2",
                                options: _vm.flyerDropzoneOptions,
                                destroyDropzone: false,
                                headers: _vm.flyerDropzoneOptions.headers,
                                name: "file1"
                              },
                              on: {
                                "vdropzone-removed-file":
                                  _vm.removeSelectedFlyer,
                                "vdropzone-success": _vm.flyerFileSuccess,
                                "vdropzone-duplicate-file": _vm.duplicateFlyer,
                                "vdropzone-total-upload-progress":
                                  _vm.progressOfUloadFlyer
                              }
                            })
                          ]
                        : [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.flyerURL,
                                  expression: "flyerURL"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "flyerURL",
                                placeholder: "Flyer URL"
                              },
                              domProps: { value: _vm.flyerURL },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.flyerURL = $event.target.value
                                }
                              }
                            })
                          ],
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.flyerCropError))
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pamphlet_label,
                            expression: "pamphlet_label"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "title",
                          placeholder: "Extra Content 2 Label",
                          maxlength: "190"
                        },
                        domProps: { value: _vm.pamphlet_label },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pamphlet_label = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isPamphletUploaded
                        ? _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.pamphlet_labelError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("span", { attrs: { id: "pamphletForm" } }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pamphletRadioValue,
                                expression: "pamphletRadioValue"
                              }
                            ],
                            attrs: {
                              id: "pamphletUploadManually",
                              type: "radio",
                              name: "pamphletRadioValue",
                              value: "pamphletDoc",
                              checked: "checked"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.pamphletRadioValue,
                                "pamphletDoc"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.pamphletRadioValue = "pamphletDoc"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Upload Docs\n                                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pamphletRadioValue,
                                expression: "pamphletRadioValue"
                              }
                            ],
                            attrs: {
                              id: "pamphletVideopUrl",
                              type: "radio",
                              name: "pamphletRadioValue",
                              value: "pamphletURL"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.pamphletRadioValue,
                                "pamphletURL"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.pamphletRadioValue = "pamphletURL"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Enter URL\n                                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isPamphletDoc
                        ? [
                            _c("vue-dropzone", {
                              ref: "pamphletDropzone",
                              attrs: {
                                id: "drop3",
                                options: _vm.pamphletDropzoneOptions,
                                destroyDropzone: false,
                                headers: _vm.pamphletDropzoneOptions.headers,
                                name: "file2"
                              },
                              on: {
                                "vdropzone-removed-file":
                                  _vm.removeSelectedPamphlet,
                                "vdropzone-success": _vm.pamphletFileSuccess,
                                "vdropzone-duplicate-file":
                                  _vm.duplicatePamphlet,
                                "vdropzone-total-upload-progress":
                                  _vm.progressOfUloadPamphlet
                              }
                            })
                          ]
                        : [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pamphletURL,
                                  expression: "pamphletURL"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "pamphletURL",
                                placeholder: "Pamphlet URL"
                              },
                              domProps: { value: _vm.pamphletURL },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.pamphletURL = $event.target.value
                                }
                              }
                            })
                          ],
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.pamphletCropError))
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ability_label,
                            expression: "ability_label"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "title",
                          placeholder: "Extra Content 3 Label",
                          maxlength: "190"
                        },
                        domProps: { value: _vm.ability_label },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.ability_label = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isAbilityUploaded
                        ? _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.ability_labelError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("span", { attrs: { id: "pamphletForm" } }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.abilityRadioValue,
                                expression: "abilityRadioValue"
                              }
                            ],
                            attrs: {
                              id: "abilityUploadManually",
                              type: "radio",
                              name: "abilityRadioValue",
                              value: "abilityDoc",
                              checked: "checked"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.abilityRadioValue,
                                "abilityDoc"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.abilityRadioValue = "abilityDoc"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Upload Docs\n                                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.abilityRadioValue,
                                expression: "abilityRadioValue"
                              }
                            ],
                            attrs: {
                              id: "abilityVideopUrl",
                              type: "radio",
                              name: "abilityRadioValue",
                              value: "abilityURL"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.abilityRadioValue,
                                "abilityURL"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.abilityRadioValue = "abilityURL"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                        Enter URL\n                                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isAbilityDoc
                        ? [
                            _c("vue-dropzone", {
                              ref: "abilityDropzone",
                              attrs: {
                                id: "drop3",
                                options: _vm.abilityDropzoneOptions,
                                destroyDropzone: false,
                                headers: _vm.abilityDropzoneOptions.headers,
                                name: "file2"
                              },
                              on: {
                                "vdropzone-removed-file":
                                  _vm.removeSelectedAbility,
                                "vdropzone-success": _vm.abilityFileSuccess,
                                "vdropzone-duplicate-file":
                                  _vm.duplicateAbility,
                                "vdropzone-total-upload-progress":
                                  _vm.progressOfUloadAbility
                              }
                            })
                          ]
                        : [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.abilityURL,
                                  expression: "abilityURL"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "abilityURL",
                                placeholder: "Ability URL"
                              },
                              domProps: { value: _vm.abilityURL },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.abilityURL = $event.target.value
                                }
                              }
                            })
                          ],
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.abilityCropError))
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "col-12 paddingleft0" }, [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addBenifitBtn",
                        type: "submit",
                        value: "Save"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addBenefit()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addAndContinueBenifitBtn",
                        type: "submit",
                        value: "Save and Continue"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addBenefit(
                            (_vm.flag = "Save and Continue")
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "back_button btn btn-primary",
                      attrs: {
                        id: "CancelBenifit",
                        type: "submit",
                        value: "Cancel"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationType" } }, [
        _vm._v("Location Type :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "mediaCaption" } }, [
        _vm._v("Banner :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Description :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "contactno" } }, [
        _vm._v("Toll Free Number :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "flyer_label" } }, [
        _vm._v("Extra Content 1 Label :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop2" } }, [
        _vm._v("Extra Content 1 :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "pamphlet_label" } },
        [_vm._v("Extra Content 2 Label :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop3" } }, [
        _vm._v("Extra Content 2 :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "ability_label" } },
        [_vm._v("Extra Content 3 Label :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop3" } }, [
        _vm._v("Extra Content 3 :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7bf60aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7bf60aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/benefits/AddBenefitCommunications.vue
// module id = null
// module chunks = 